import {addOtaAccountList} from "@/api/api";
import {message} from "ant-design-vue";
import isElectron from 'is-electron';

let newWin

export default {
    state: {
        OtaTask: [], //ota 任务清单
        OtaList: [], //ota 账号列表
    },

    getters: {
        // 返回渠道账号长度
        getOtaList(state) {
            return state.OtaList.length
        },

        // 获取渠道列表
        getChannelList(state) {
            return state.channelList
        },

    },

    mutations: {

        // 储存定时任务
        saveOtaTask(state, data) {
            state.OtaTask = data
        },

        // 储存渠道账号
        saveOtaList(state, data) {
            state.OtaList = data
        },

        // 储存渠道列表
        saveChannelList(state, data) {
            state.channelList = data
        },

        // 打开OTA登录网址
        openWindow(state, params) {
            // 判断是否在 OTA应用 打开
            if (!isElectron()) {
                message.error("请使用OTA应用打开！");
                return;
            }
            let iWidth = 600;
            let iHeight = 600;
            let iTop = (window.screen.height - 30 - iHeight) / 2; //获得窗口的垂直位置;
            let iLeft = (window.screen.width - 10 - iWidth) / 2; //获得窗口的水平位置;
            newWin = window.open(
                params.login_url,
                "newWindow",
                `width=${iWidth},height=${iHeight},left=${iLeft},top=${iTop},location=no`
            );
        }
    },

    actions: {
        handleOtaType(context, params) {
            let obj = {
                ...params
            }
            switch (obj.type) {
                case 'ota_refresh_request':
                    window.location.reload()
                    break;
                case 'user_identify':
                    addOtaAccountList().then(res => {
                        res.data.some(item => {
                            if (item.id == obj.ota_id) {
                                context.commit('openWindow', item)
                                return
                            }
                        })
                    })
                    break
                case 'CLOSE_TJ_WEBSITE_WINDOW':
                    setTimeout(() => {
                        window.location.reload()
                    }, 1000);
                    newWin.close()
                    break
                default:
                    break;
            }
        }
    }
}